import { encrypt } from "../controllers/crypto.controller";
import { information } from "../information";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { isMobile, isTablet } from "react-device-detect";

export const getCodeClient = async (promo_code) => {
  const { endpoint, site } = information;

  let myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  let isDesktop = false;
  isDesktop = await getDeviceType();
  let deviceType =
    isMobile || isTablet ? (isDesktop ? "desktop" : "mobile") : "desktop";
  myHeaders.append("device", deviceType);

  let objParam = {
    promo_code: promo_code,
  };
  let encryptHandle = encrypt(JSON.stringify(objParam));
  let raw = JSON.stringify({
    key: encryptHandle,
    deviceType: deviceType,
  });
  let requestOptions = {
    method: "POST",
    redirect: "follow",
    headers: myHeaders,
    body: raw,
  };
  return fetch(
    endpoint + "/client/get-code?promo_code=" + promo_code + "&site=" + site,
    requestOptions
  )
    .then((response) => response.json())
    .then((result) => {
      return result;
    })
    .catch((error) => console.log("error", error));
};

export const addPointClient = async (player_id, promo_code, captchaTokenGG) => {
  const { endpoint, site } = information;
  let myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  let objParam = {
    promo_code: promo_code,
  };

  let encryptHandle = encrypt(JSON.stringify(objParam));
  let raw = JSON.stringify({
    key: encryptHandle,
    captchaTokenGG: captchaTokenGG,
  });

  let requestOptions = {
    method: "POST",
    redirect: "follow",
    headers: myHeaders,
    body: raw,
  };

  return fetch(
    endpoint +
      "/client?player_id=" +
      player_id +
      "&promo_code=" +
      promo_code +
      "&site=" +
      site,
    requestOptions
  )
    .then((response) => response.json())
    .then((result) => {
      return result;
    })
    .catch((error) => console.log("error", error));
};

const getDeviceType = async () => {
  try {
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    const platform = result.components.platform?.value;
    const vendor = result.components.vendor?.value;
    const desktopKeywords = [
      "Win32",
      "Win64",
      "Windows NT",
      "MacIntel",
      "Macintosh",
      "Linux x86_64",
      "Linux i686",
      "X11",
      "FreeBSD",
      "OpenBSD",
      "NetBSD",
      "CrOS",
      "SunOS",
      "Solaris",
      "Haiku",
      "AIX",
      "HP-UX",
    ];
    const mobileKeywords = [
      "Android",
      "iPhone",
      "iPad",
      "iPod",
      "Mobile",
      "Tablet",
      "webOS",
      "BlackBerry",
      "Opera Mini",
      "IEMobile",
      "Silk",
      "armv7",
      "armv8",
      "Linux armv81",
      "Linux aarch64",
      "MeeGo",
      "Maemo",
      "Tizen",
      "KaiOS",
      "Bada",
      "Symbian",
    ];
    const isDesktop =
      desktopKeywords.some((keyword) => platform.includes(keyword)) &&
      !mobileKeywords.some((keyword) => vendor.includes(keyword));
    return isDesktop;
  } catch (error) {
    console.error("Error:", error);
    return false;
  }
};
